"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as React from "react";
export const DEFAULT_SLIDER_CONFIG = {
    navSpacing: 3,
    navShadow: false,
    autoplay: false,
    delay: 4000,
    iconArrows: true,
    animation: "slide",
    navNumbers: true,
    easing: "ease",
    navRound: true,
    hideArrows: false,
    disableSwipe: false,
    duration: 500,
    infinite: true,
    autoMax: 0,
    navInvert: false
};
export const SliderContext = /*#__PURE__*/ React.createContext(_object_spread_props(_object_spread({}, DEFAULT_SLIDER_CONFIG), {
    slideAmount: 0,
    setSlideAmount: ()=>undefined,
    setCurrentSlide: ()=>undefined,
    goToNextSlide: ()=>undefined,
    goToPreviousSlide: ()=>undefined,
    slide: {
        current: 0,
        previous: 0
    },
    isAutoplayPaused: false,
    setAutoplayPause: ()=>undefined
}));
